module.exports = __webpack_public_path__ + "img/align-top-02.6dc02e95.svg";